import {Component, Input, OnInit} from '@angular/core';
import {GlobalService} from "../../../../global.service";
import {EventsService} from "../../../events.service";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-halloween-tournaments',
  templateUrl: './halloween-tournaments.component.html',
  styleUrls: ['./halloween-tournaments.component.css']
})
export class HalloweenTournamentsComponent implements OnInit {
  
  
  constructor(public globalService: GlobalService, public eventService: EventsService, private activeRoute: ActivatedRoute) {
  }
  
  ngOnInit() {
    this.activeRoute.params.subscribe(param => {
      this.changeRoute(param['code']);
    });
  }
  
  changeRoute(param) {
    this.eventService.loadEventTournaments = true;
    this.eventService.getEventTournaments('halloween-nights', 1, param).subscribe(res => {
      this.eventService.eventTournaments.next(res);
      this.eventService.loadEventTournaments = false;
    },error=>this.eventService.loadEventTournaments = false)
  }
  
}
